export default "__VITE_ASSET__8$YbTga2__"